import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ExpenseUiWebComponentsModule } from '@ems-gui/expense/ui-web-components';
import { DropzoneModule } from 'nxt-dropzone-wrapper';
import { ExpenseStatusComponent } from './components/expense-status/expense-status.component';
import { ExpenseSummaryComponent } from './components/expense-summary/expense-summary.component';
import { ExpenseFeatureWebDashboardRoutingModule } from './expense-feature-web-dashboard-routing.module';
import { DashboardPageComponent } from './pages/dashboard-page/dashboard-page.component';

@NgModule({
  imports: [
    CommonModule,
    ExpenseUiWebComponentsModule,
    DropzoneModule,
    ExpenseFeatureWebDashboardRoutingModule,
  ],
  declarations: [
    ExpenseStatusComponent,
    ExpenseSummaryComponent,
    DashboardPageComponent,
  ],
  exports: [],
})
export class ExpenseFeatureWebDashboardModule {}
